// src/pages/PortfolioShowcase.js
import React from "react";
import {
  Box,
  Heading,
  SimpleGrid,
  Image,
  Text
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useProducts } from "../pages/ProductContext";
import DevelopmentModal from "../components/DevelopmentModal";

const PortfolioShowcase = () => {
  const { products } = useProducts();

  return (
    <Box px={{ base: 2, md: 50 }} py={{ base: 8, md: 100 }} bg="#cfe2cf" width="100%">
      <Heading as="h2" fontWeight="thin" size="xl" textAlign="center">
        Mitt Arbeid
      </Heading>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} mt={8}>
        {products.map((item) => (
          <Box
            key={item.id}
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            boxShadow="md"
          >
            <RouterLink to={`/product/${item.id}`}>
              <Image
                src={item.imageUrl}
                alt={item.name}
                objectFit="cover"
                width="100%"
                height="200px"
              />
            </RouterLink>
            <Box p={4}>
              <Heading as="h3" size="md" mb={2}>
                <RouterLink to={`/product/${item.id}`}>
                  {item.name}
                </RouterLink>
              </Heading>
              <Text mb={2}>{item.description}</Text>
              {/* Knappen som åpner modalen, med alle bilder i item.gallery */}
              <DevelopmentModal images={item.gallery} />
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default PortfolioShowcase;